import { jsx as _jsx } from "react/jsx-runtime";
import { experimentalStyled } from '@mui/material/styles';
import { COLORS } from '../../constants/theme';
const CardContainer = experimentalStyled('div')(({ theme }) => ({
    background: COLORS.GRAY_BLUE,
    borderRadius: '12px',
    borderSpacing: '0',
    fontFamily: theme.fonts.primary,
}));
const Card = ({ children, sx, className }) => {
    return (_jsx(CardContainer, { sx: sx, className: className, children: children }));
};
export default Card;
//# sourceMappingURL=Card.js.map